import { render, staticRenderFns } from "./iconBtn.vue?vue&type=template&id=a9d7dcd2&scoped=true"
import script from "./iconBtn.vue?vue&type=script&lang=js"
export * from "./iconBtn.vue?vue&type=script&lang=js"
import style0 from "./iconBtn.vue?vue&type=style&index=0&id=a9d7dcd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d7dcd2",
  null
  
)

export default component.exports